
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 13.906l-6-1.719V.126l6 1.719v12.062zm1-12.125L16.969.188C17.437 0 18 .344 18 .875v10.469a.703.703 0 01-.5.687L13 13.844V1.78zM.469 2L5 .187V12.25l-4 1.594a.733.733 0 01-1-.688V2.687C0 2.376.156 2.095.469 2z","fill":"#fff"}})])
          )
        }
      }
    